import { twMerge } from 'tailwind-merge'
import { USDDollarFormatter } from '../util'
import clsx, { ClassValue } from 'clsx'

export const filterButtons = [
  {
    name: 'Last 24H',
    value: '1d',
  },
  {
    name: 'Last 7 Days',
    value: '7d',
  },
  {
    name: 'Last 30 Days',
    value: '1m',
  },
  {
    name: 'All Time',
    value: '',
  },
  {
    name: 'Custom',
    value: '',
  },
]

export const columns = [
  {
    Header: 'Username',
    accessor: 'username',
    sortId: 'user.name',
    // Cell: (props: { value: IUserDetails | null }) => {
    //   return <UserColumn image={props.value?.profile_picture} username={props.value?.name || 'N/A'} address={props.value?.address || 'N/A'} />
    // },
  },
  {
    Header: 'Account Created',
    accessor: 'createdAt',
    // disableFilters: true,
    // sortType: (a:any, b:any) => {
    //   // @ts-ignore
    //   return new Date(b.values.createdAt) - new Date(a.values.createdAt)
    // },
    // sortType: (a: any, b: any) => {
    //   const a1 = new Date(a.values.createdAt).getTime()
    //   const b1 = new Date(b.values.createdAt).getTime()
    //   if (a1 < b1) return 1
    //   else if (a1 > b1) return -1
    //   else return 0
    // },
  },
  {
    Header: 'Last Login',
    accessor: 'updatedAt',
    // disableFilters: true,
    // sortType: (a:any, b:any) => {
    //   // @ts-ignore
    //   return new Date(b.values.createdAt) - new Date(a.values.createdAt)
    // },
    // sortType: (a: any, b: any) => {
    //   const a1 = new Date(a.values.updatedAt).getTime()
    //   const b1 = new Date(b.values.updatedAt).getTime()
    //   if (a1 < b1) return 1
    //   else if (a1 > b1) return -1
    //   else return 0
    // },
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Total NettyWorth',
    accessor: 'totalNettyworth',
    Cell: (props: { value: string | number }) => {
      return (
        <p className='font-medium text-[14px] text-input'>
          {typeof props.value === 'number' ? USDDollarFormatter(Number(props.value), 'USD') : props.value}
        </p>
      )
    },
  },  
  {
    Header: 'Total Crypto Value',
    accessor: 'ethUsdValue',
    Cell: (props: { value: string | number }) => {
      return (
        <p className='font-medium text-[14px] text-input'>
          {typeof props.value === 'number' ? USDDollarFormatter(Number(props.value), 'USD') : props.value}
        </p>
      )
    },
  },
  {
    Header: 'Total NFT Value',
    accessor: 'nftUsdBalance',
    Cell: (props: { value: string | number }) => {
      return (
        <p className='font-medium text-[14px] text-input'>
          {typeof props.value === 'number' ? USDDollarFormatter(Number(props.value), 'USD') : props.value}
        </p>
      )
    },
  },
]

export const cn = (...classes: ClassValue[]) => twMerge(clsx(...classes));

export const truncateAddress = (address: string | undefined) => {
  if (!address) return 'No Account';
  const match = address.match(/^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/);
  if (!match) return address;
  return `${match[1]}…${match[2]}`;
};

export const FILE_BASE_URL = 'https://s3.us-east-1.amazonaws.com/profile.nettyworth.io';

export const AWSImageConverter = (url: string) => {
  return `${FILE_BASE_URL}/${url}`;
};